export default "/images/image-placeholder.png?b03e7ce5c5456ded825532951c4751e3";